export default "__VITE_ASSET__BwfhANxr__"